import $ from 'jquery';
import ScrollMagic from 'ScrollMagic';
import 'slick-carousel'

// prettier-ignore
const main = () => {
    $(function() {
        //$('body').prepend('<div class="ruler" style="height:1px; width:1000px; z-index:10000; background:red; position:fixed; top:322px;">');
        //$('body').prepend('<div class="ruler" style="height:1px; width:1000px; z-index:10000; background:red; position:fixed; top:126px;">');



        var navContainer = $('.main-menu-wrapper');
        var headerContainer = $('header.header');
        var menuTextContainer = $('.menu-text');
        /* HAMBURGER */
        $('.burger').on('click', 'img', () => {
            $('.burger img').toggleClass('hide');
            $(navContainer).toggleClass('hide');
            $(navContainer).css('top', $(headerContainer).height() + "px");
            $(headerContainer).toggleClass('beige-background');
            $('.contact-anchor').toggleClass('hide-visibility-mobile black');
            $('.contact-anchor').toggleClass('hide');
            $(menuTextContainer).toggleClass('black');
            //$(menuTextContainer).html() == "menu" ? $(menuTextContainer).html('close') : $(menuTextContainer).html('menu');

            if (!$(navContainer).hasClass('hide')) {
                $(navContainer).css('position', 'fixed');
                $(headerContainer).css('position', 'fixed');
                if ($(window).width() < 1365) {
                    $('body').css('height', '100vh');
                    $('body').css('overflow', 'hidden');
                    navContainer.addClass('menu-open');
                }
            } else {
                $(navContainer).css('position', 'absolute');
                $(headerContainer).css('position', 'absolute');
                if ($(window).width() < 1365) {
                    $('body').css('height', 'unset');
                    $('body').css('overflow', 'unset');
                    navContainer.removeClass('menu-open');
                }
            }
        });

        $('.contact-anchor').on('click', function(e) {
            console.log('klick kontakt');
            e.preventDefault();
            $(navContainer).css('position', 'absolute');
            $(headerContainer).css('position', 'absolute');
            var kontakt_tag = $('a[name="kontakt"]');
            $('html,body').animate({ scrollTop: kontakt_tag.offset().top }, 'slow');
        });

        /* Toggles FAQs */
        $('.FAQs .toggle-wrapper,.kontaktform .toggle-wrapper').on('click', function() {
            console.log('click');
            var is_active = false;
            if ($(this).hasClass('active')) {
                is_active = true;
            }
            $('.FAQs .toggle-wrapper').removeClass('active');
            $(this).addClass('active');



            $('.FAQs .toggle-wrapper:not(.active) .toggle-content,.kontaktform .toggle-wrapper:not(.active) .toggle-content').hide(10);
            if (!is_active) {
                $(this).find('.toggle-content').show(10);
            } else {
                $(this).removeClass('active');
                $(this).find('.toggle-content').hide(10);
            }

        });

        /* Toggles Footer */
        $('.toggle-title-footer').on('click', function() {
            $(this).toggleClass('active');
            $(this).next('.contact-content').toggleClass('hidden');
        });


        /* Klick Anker im Videocontainer */
        $('.video-container .title-anchor-container a.more').on('click', function(e) {
            e.preventDefault();
            $('.video-container .dependance-slider-desktop .slick-slide.slick-active .dependance-name span.active').trigger('click');

            var aid = $('.video-container .dependance-slider-desktop .slick-slide.slick-active .dependance-name span.active').text();
            var aTag = $('a[name="' + aid + '"]');
            var bTag = $('a[name="' + aid + '"]').find('+ .block-wrapper img');

            $('html,body')
                .animate({ scrollTop: bTag.offset().top }, 'slow');

        });

        // News Slider
        $('.news-slider').slick({
            slidesToShow: 2.5,
            slidesToScroll: 1,
            arrows: false,
            dots: true,
            infinite: false,
            responsive: [{
                breakpoint: 601,
                settings: {
                    slidesToShow: 1.5
                }
            }]
        });
        $(window).on('resize', function() {

            // init controller
            var controller = new ScrollMagic.Controller();
            var scene = null;

            // hier werden die zahlen reingeflogen und fixiert.
            if ($(window).width() >= 600) {
                $('.number').each(function(index) {
                    // build a scene
                    var scene = new ScrollMagic.Scene({
                            duration: 360, // the scene should last for a scroll distance of 400px
                            offset: (800 * (index + 1)) - (index * 82) // start this scene after scrolling for 800px
                        })
                        .setPin(this) // pins the element for the the scene's duration
                        .addTo(controller) // assign the scene to the controller
                });
            }
            // destroy controller for mobile devices
            if ($(window).width() < 600 && scene) {
                scene.destroy(true);
                scene = null;
                controller.destroy(true);
                controller = null;
            }

            // title in der hoehe platzieren.
            if ($(window).height() <= 774) {
                $('.title-anchor-container').css('top', '249.5px');
            } else {
                var height_title = $('.title-anchor-container').height();
                var height_window = $(window).height();
                var new_title_top = (height_window - height_title) / 2;
                //console.log('new_title_top', new_title_top);
                $('.title-anchor-container').css('top', new_title_top + 'px');
            }
            if ($('body.home').length) {
                var margin = $('.main-content > .grid-container').css('margin-left');
                $('section.news .news-slider').css('margin-left', margin);
                $('section.news .slick-dots').css('left', '-' + margin).css('margin-right', margin);
            }
        });
        $(window).trigger('resize');

        // add placeholder in forms
        if ($('#kontaktform').length) {
            $('#kontaktform input, #kontaktform textarea').each(function() {
                var placeholder = $(this).parent().find('~ label').text();
                $(this).attr('placeholder', placeholder);

            });
            $('#kontaktform form').css('display', 'block');

        }


    });
};
export default main;


// WEBPACK FOOTER //
// ./src/scripts/modules/main.js